import React from 'react';
import { RefreshCw, Loader2 } from 'lucide-react';

import { Button } from '../ui/button';

// Reissue CTA hides when `onReissue` is omitted.
const BuyerPickupCodeCard = ({
  code,
  expiresAt,
  reissueInProgress,
  onReissue,
  className,
}) => {
  if (!code) return null;
  const groupedCode =
    code.length > 3 ? `${code.slice(0, 3)}\u2003${code.slice(3)}` : code;
  const wrapperClass = `rounded-lg border border-green-500/20 bg-[linear-gradient(180deg,rgba(245,255,249,1),rgba(239,250,244,1))] p-4 shadow-[0_18px_36px_-32px_rgba(34,197,94,0.25)]${
    className ? ` ${className}` : ''
  }`;
  return (
    <article className={wrapperClass}>
      <h4 className="font-heading text-sm font-bold uppercase text-green-800">
        Your pickup code
      </h4>
      <div className="mt-2 text-xs leading-5 text-foreground/80">
        Only share the pickup code after you have inspected and are ready to release payment.
      </div>
      <div className="mt-3 rounded-md border-2 border-dashed border-green-500/30 bg-white/90 p-3 text-center">
        <div className="font-mono text-4xl font-bold tracking-[0.15em] text-primary leading-none">
          {groupedCode}
        </div>
        {expiresAt ? (
          <div className="mt-2 text-[10px] text-muted-foreground">
            Expires{' '}
            {new Date(expiresAt).toLocaleString(undefined, {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              timeZoneName: 'short',
            })}
          </div>
        ) : null}
      </div>
      {onReissue ? (
        <Button
          type="button"
          variant="outline"
          disabled={reissueInProgress}
          onClick={onReissue}
          className="mt-3 w-full rounded-lg font-heading uppercase border-green-500/40 text-green-800 hover:bg-green-50"
        >
          {reissueInProgress ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Refreshing…
            </>
          ) : (
            <>
              <RefreshCw className="mr-2 h-4 w-4" />
              Get a new code
            </>
          )}
        </Button>
      ) : null}
    </article>
  );
};

export default BuyerPickupCodeCard;
